import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as employee from '../employee'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: employee.RESOURCE.payload.dimension.partialId,
      partialId: employee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'S3 file name for employee resume/CV',
    isOptional: true,
    name: 'Resume File Name',
    partialId: PartialId.Standard.create('resume_file'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
